import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgExhibition48 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "currentColor",
  "aria-label": "Exhibition",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M42 42h-1V31.8c1.4-.4 2.5-1.8 2.5-3.3 0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5c0 1.1.5 2.1 1.3 2.7-8.5 5-19.1 5-27.6 0 .8-.6 1.3-1.6 1.3-2.7 0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5c0 1.6 1.1 2.9 2.5 3.3V42H6c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1H9v-9.2c4.6 2.7 9.8 4.1 15 4.1s10.4-1.4 15-4.1V42h-1c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1M6.5 28.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5S8.8 30 8 30s-1.5-.7-1.5-1.5M40 27c.8 0 1.5.7 1.5 1.5S40.8 30 40 30s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 27h14c.6 0 1-.4 1-1V10c0-.6-.4-1-1-1h-1.6l-4.7-4.7c-.4-.4-1-.4-1.4 0L18.6 9H17c-.6 0-1 .4-1 1v16c0 .6.4 1 1 1m7-20.6L26.6 9h-5.2zM18 11h12v14H18z"
}));

export { SvgExhibition48 as default };
//# sourceMappingURL=Exhibition48.js.map
